export const EXTERNAL_URLS = {
  SUPPORT_EMAIL: 'mailto:rentalsupport@zillow.com',
  CORP_TERMS: 'https://www.zillow.com/corp/Terms.htm',
  RENTAL_USER_TERMS: 'https://www.zillow.com/renter-hub/terms/Rental-User-Terms',
  PLEDGE: 'https://www.zillow.com/corp/respectful-renting-pledge/',
  LISTING_DECLINED: 'https://www.zillow.help/article/why-didnt-my-listing-go-live-zd30234367973523',
  DISCONTINUING_RENTAL_PROTECTION: 'https://www.zillow.help/article/discontinuing-rental-protection-zd39604170235155',
  RENTAL_PROTECTION_DETAILS_COVERAGE:
    'https://wp-tid.zillowstatic.com/1/Rental-Protection-Coverage-Summary-FINAL-April-2022-c864d0.pdf',
  ROOM_FOR_RENT_LEARN_MORE: 'https://www.zillow.help/article/listing-decline-reasons-zd32916084754579',
  STREETEASY_HOME: 'https://streeteasy.com/',
  CA_AB_723: 'https://leginfo.legislature.ca.gov/faces/billNavClient.xhtml?bill_id=202520260AB723',
} as const;
